import React from 'react'
import Hero from '../components/Hero'
import About from '../components/About'
import Utilities from '../components/Utilities'
import TOKENOMICS from '../components/TOKENOMICS'
import REVENUESHARING from '../components/REVENUESHARING'
import BENEFITS from '../components/BENEFITS'
import Roadmap from '../components/Roadmap'

export default function Home() {
  return (
    <>
      <Hero />
      <div className='lg:px-32 md:px-16 px-5'>
        <About />
        <Utilities />
        <TOKENOMICS />
        <REVENUESHARING />
        <BENEFITS />
        <Roadmap />
      </div>
    </>
  )
}
